import { notificationConstant } from "../_constants";
import { APIcallFunction, headerForPrivateAPI } from "../_helpers";
import { alertActions } from "./alert.actions";




const getUserList = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: "/customer/list"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(success(customer));

            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: notificationConstant.GET_USER_LIST_REQUEST, customer }; }
        function success(customer) { return { type: notificationConstant.GET_USER_LIST_SUCCESS, customer }; }
        function failure(error) { return { type: notificationConstant.GET_USER_LIST_FAILURE, error }; }

    } catch (error) {
        console.log("Error at customerList", error);
    }
}


const getNotificationList = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: "/notification/list"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(success(customer));

            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: notificationConstant.GET_NOTIFICATION_LIST_REQUEST, customer }; }
        function success(customer) { return { type: notificationConstant.GET_NOTIFICATION_LIST_SUCCESS, customer }; }
        function failure(error) { return { type: notificationConstant.GET_NOTIFICATION_LIST_FAILURE, error }; }

    } catch (error) {
        console.log("Error at customerList", error);
    }
}


const sendNotification = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: "/notification/sendNotification"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(getNotificationList());
                dispatch(success(customer));
                dispatch(alertActions.success("Notification Send Successfully"))

            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: notificationConstant.SEND_NOTIFICATION_REQUEST, customer }; }
        function success(customer) { return { type: notificationConstant.SEND_NOTIFICATION_SUCCESS, customer }; }
        function failure(error) { return { type: notificationConstant.SEND_NOTIFICATION_FAILURE, error }; }

    } catch (error) {
        console.log("Error at customerList", error);
    }
}
export const notificationAction = {
    getUserList,
    getNotificationList,
    sendNotification

}




